import { NgModule } from '@angular/core';
import { pgDatePipe } from './pg-date.pipe';

@NgModule({
  declarations: [ pgDatePipe ],
  exports     : [ pgDatePipe ]
})
export class pgUtilModule {

}



// WEBPACK FOOTER //
// /home/jenkins/hornbillfx-elms-v2/src/app/@hornbillfx/components/util/pg-util.module.ts